import { useParams } from 'react-router';
import { FALLBACK_LANGUAGE } from '../../../../constants';

/**
 * Get the language from the URL path match or fallback to the provided fallback language.
 * @deprecated
 */
export const useLang = (fallback = FALLBACK_LANGUAGE) => {
  const match = useParams<{ lang?: string }>();
  return match.lang ?? fallback;
};